import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Modal para mostrar errores de timbrado de Prodigia
 */
const ModalErrorTimbrado = ({ show, onHide, errorMessage, errorCode }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            aria-labelledby="error-timbrado-modal"
            centered
            backdrop="static"
        >
            <Modal.Header className="bg-danger text-white">
                <Modal.Title id="error-timbrado-modal" className="d-flex align-items-center">
                    <FontAwesomeIcon icon="exclamation-circle" className="me-2" />
                    Error en el Timbrado
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center mb-3">
                    <FontAwesomeIcon 
                        icon="times-circle" 
                        size="4x" 
                        className="text-danger"
                    />
                </div>
                
                {errorCode && (
                    <div className="alert alert-warning mb-3">
                        <strong>Código de Error:</strong> {errorCode}
                    </div>
                )}
                
                <div className="alert alert-danger mb-0">
                    <div className="mb-2">
                        <strong>Mensaje de Error:</strong>
                    </div>
                    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {errorMessage}
                    </div>
                </div>

                <div className="mt-3 text-muted small">
                    <FontAwesomeIcon icon="info-circle" className="me-2" />
                    Por favor, corrija el error y vuelva a intentar timbrar la factura.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant="danger" 
                    onClick={onHide}
                    className="w-100"
                >
                    <FontAwesomeIcon icon="times" className="me-2" />
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalErrorTimbrado.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    errorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ModalErrorTimbrado;
